<template>
  <div>
    <template v-if="showMenu">
      <ul class="nav">
        <li
          :class="{
            selected: currentPath == '/hr/recruiter/home' ? true : false,
          }"
        >
          <router-link to="/hr/recruiter/home?type=tab" :class="[lang]">
            {{ $t("home") }}</router-link
          >
        </li>
        <li
          :class="{
            selected: currentPath == '/hr/recruiter/campaign' ? true : false,
          }"
        >
          <router-link to="/hr/recruiter/campaign" :class="[lang]">{{
            $t("campaigns")
          }}</router-link>
        </li>
        <li
          :class="{
            selected: currentPath == '/hr/recruiter/dashboard' ? true : false,
          }"
        >
          <router-link to="/hr/recruiter/dashboard" :class="[lang]">{{
            $t("dashboard")
          }}</router-link>
        </li>
        <li
          :class="{
            selected: currentPath == '/hr/recruiter/linkin' ? true : false,
          }"
        >
          <router-link to="/hr/recruiter/linkin" :class="[lang]">{{
            $t("linkedinAccountSetting")
          }}</router-link>
        </li>
        <li
          :class="{
            selected: currentPath == '/hr/recruiter/draft' ? true : false,
          }"
        >
          <router-link to="/hr/recruiter/draft" :class="[lang]">{{
            $t("campaignDraft")
          }}</router-link>
        </li>
      </ul>
    </template>
    <template v-else>
      <p class="back">
        <span @click="goback"
          ><a-icon type="left" /><span :class="[lang]">{{
            $t("back")
          }}</span></span
        >
      </p>
    </template>
    <!-- <keep-alive v-if="$route.meta.KeepAlive">
      <router-view></router-view>
    </keep-alive> -->
    <keep-alive>
      <div>
        <!-- <DraftStep :isSales="false" /> -->
        <div style="height: 50px"></div>
        <PostTitle :isSales="false" />
      </div>
      <router-view
        v-if="$route.meta.KeepAlive"
        :exclude="['createCampaign', '/hr/recruiter/createCampaign']"
        :key="$route.path"
      />
    </keep-alive>
    <router-view v-if="!$route.meta.KeepAlive"></router-view>
    <PayModal camp="2" />
    <!-- <PostSuccessModal
    /> -->
  </div>
</template>
<script>
// import DraftStep from "../../sales/salesReps/component/DraftStep";
// import PostSuccessModal from '../../sales/salesReps/component/PostSuccessModal.vue';
import PayModal from "@/components/publicPayModal/index.vue";

import PostTitle from "../../sales/salesReps/component/PostTitle.vue";

export default {
  data() {
    return {
      showMenu: true,
    };
  },
  components: {
    // DraftStep,
    // PostSuccessModal,
    PayModal,
    PostTitle,
  },
  i18n: require("./i18n"),

  watch: {
    $route(to) {
      if (to.path == "/hr/recruiter/dialogue") {
        this.showMenu = false;
      } else if (to.path == "/hr/recruiter/createCampaign") {
        this.showMenu = false;
      } else if (to.path == "/hr/recruiter/campaignDetail") {
        this.showMenu = false;
      } else if (to.path == "/hr/recruiter/collectUserInfo") {
        this.showMenu = false;
      } else {
        this.showMenu = true;
      }
    },
  },
  computed: {
    currentPath: {
      get() {
        return this.$route.path;
      },
    },
  },

  created() {
    this.showMenu = this.showMenu2();
  },
  methods: {
    goback() {
      this.$router.go(-1);
    },
    showMenu2() {
      if (this.$route.path == "/hr/recruiter/dialogue") {
        return false;
      } else if (this.$route.path == "/hr/recruiter/createCampaign") {
        return false;
      } else if (this.$route.path == "/hr/recruiter/campaignDetail") {
        return false;
      } else if (this.$route.path == "/hr/recruiter/collectUserInfo") {
        return false;
      } else {
        return true;
      }
    },
    goPage() {
      window.open("https://youtu.be/l-YBhSImsDs?si=DHBD-zTBpsIbSLC8");
    },
  },
};
</script>
<style scoped lang="less">
.nav {
  width: 100%;
  padding-top: 7px;
  padding-left: 30px;
  border-top: #d1d1d1 solid 1px;
  min-width: calc(1200px - 254px);
  background: red;
  li {
    height: 42px;
    line-height: 42px;
    padding: 0 12px;
    margin-right: 88px;
    display: inline-block;
    a {
      color: #000;
    }
    border-bottom: #fff 2px solid;
  }
  .selected {
    border-bottom: #0e756a 2px solid;
    a {
      font-weight: bold;
    }
  }
  background: #ffffff;
  box-shadow: 0px 3px 10px -5px rgba(0, 0, 0, 0.1);
  // box-shadow: 0 2px 8px -2px rgba(0, 0, 0, 0.15);
}
.nav,
.back {
  left: 254px;
  position: fixed;
  top: 64px;
  right: 0;
  z-index: 999;
}
.back {
  border-top: #d1d1d1 solid 1px;
  color: #0e756a;

  height: 50px;
  line-height: 50px;
  padding-left: 30px;
  background: #fff;
  span {
    cursor: pointer;
  }
}
.mask_bg {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  z-index: 9999;
  .caption {
    position: fixed;
    background: #fff;
    border-radius: 5px;
    height: 42px;
    line-height: 42px;
    padding: 0 12px;
    margin-right: 88px;
    display: inline-block;
    border-bottom: #fff 2px solid;
    color: #000;
    left: 420px;
    top: 73px;
    .text {
      height: 40px;
      line-height: 40px;
      padding: 0 12px;
      border-bottom: #0e756a 2px solid;
      font-weight: bold;
    }
    .des {
      color: #fff;
      font-size: 14px;
      position: absolute;
      font-weight: bold;
      width: 250px;
      margin-left: -12px;
      padding-top: 10px;
      line-height: 30px;
    }
  }
  .btn {
    width: 400px;
    position: fixed;
    top: 134px;
    left: 729px;
    z-index: 1000;
    // display: flex;
    // align-items: top;
    .guideBtn {
      padding: 0 20px;
      height: 40px;
      line-height: 40px;
      color: #fefefe;
      background-color: #0e756a;
      border-color: #0e756a;
      text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.12);
      -webkit-box-shadow: 0 2px 0 rgba(0, 0, 0, 0.045);
      box-shadow: 0 2px 0 rgba(0, 0, 0, 0.045);
      border-radius: 4px;
      display: inline-block;
    }
    .des {
      margin-top: 6px;
      display: block;
      color: #fff;
      font-size: 14px;
      font-weight: bold;
      line-height: 30px;
    }
  }
  .title {
    color: #fff;
    font-size: 24px;
    font-weight: bold;
    position: fixed;
    top: 20px;
    left: 50%;
    transform: translateX(-50%);
  }
  .guide-con {
    margin-left: 20px;
    min-width: 400px;
    color: #fff;
    font-size: 14px;
    font-weight: bold;
    line-height: 30px;
    position: fixed;
    top: 300px;
    left: 50%;
    transform: translateX(-50%);
    margin-right: 300px;
    .con-click {
      cursor: pointer;
      font-size: 16px;
    }
  }
}
</style>
